import { render, staticRenderFns } from "./TypicalCaseDetail.vue?vue&type=template&id=20cc5420&scoped=true&"
import script from "./TypicalCaseDetail.vue?vue&type=script&lang=js&"
export * from "./TypicalCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./TypicalCaseDetail.vue?vue&type=style&index=0&id=20cc5420&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc5420",
  null
  
)

export default component.exports